import { useCallback } from "react";
import {
  useDisableUser,
  useEnableUser,
} from "../mutations/useStatusUserToggle.mutation";

export const useUserStatusToggle = () => {
  const disableMutation = useDisableUser();
  const enableMutation = useEnableUser();

  const handleEnable = useCallback(
    (id: string) => {
      enableMutation.mutate(id);
    },
    [enableMutation],
  );

  const handleDisable = useCallback(
    (id: string) => {
      disableMutation.mutate(id);
    },
    [disableMutation],
  );

  return {
    handleDisable,
    isDisabling: disableMutation.isPending,
    handleEnable,
    isEnabling: enableMutation.isPending,
  };
};
